import React, { useRef, useState } from 'react';
import ControlAdvisory from 'components/financial-advisory/ControlAdvisory';
import InputAdvisory from 'components/financial-advisory/InputAdvisory';
import ResponseAdvisory from 'components/financial-advisory/ResponseAdvisory';
import { ActionButtonConfig } from 'models/ActionButtonConfig';
import { getFinancialAdvisoryResponse } from 'services/FinancialAdvisoryServices';
import fondo from 'assets/img/fondo-main.png';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';

interface Params {
	page: string;
}

function FinancialAdvisoryContainer() {
	const params = useParams<Params>();
	let history = useHistory();

	const configAction: ActionButtonConfig[] = [
		{
			stage: 0,
			buttonBackName: 'volver',
			buttonNextName: 'Quiero saber',

			buttonBackClick: () => {
				if (params.page) {
					window.location.href = `${process.env.REACT_APP_WORDPRESS_URL}/${
						params.page ? params.page : 'credito-automotriz'
					}/`;
				} else {
					history.goBack();
				}
			},
			buttonNextClick: () => {
				totalFinancial.current = getFinancialAdvisoryResponse(inputValue);
				setStage(1);
			},
		},
		{
			stage: 1,
			buttonBackName: 'volver',
			buttonNextName: 'simular cuota',

			buttonBackClick: () => {
				setStage(0);
			},
			buttonNextClick: () => {
				if (params.page) {
					window.location.href = `${process.env.REACT_APP_WORDPRESS_URL}/${
						params.page ? params.page : 'credito-automotriz'
					}/?cost_vehicle=${totalFinancial.current / 0.8}&salary=${inputValue}`;
				} else {
					history.goBack();
				}
			},
		},
	];

	const [enableButton, setEnableButton] = useState(true);
	const [inputValue, setInputValue] = useState('');
	const totalFinancial = useRef(0);
	const [stage, setStage] = useState(0);

	return (
		<div className="FinancialAdvisoryContainer">
			<img src={fondo} alt="logo" />
			<div className="FinancialAdvisoryContainer-content">
				{stage === 0 ? (
					<InputAdvisory
						inputValue={inputValue}
						setInputError={setEnableButton}
						setInputValue={setInputValue}
					/>
				) : (
					<ResponseAdvisory salary={inputValue} totalFinancial={totalFinancial.current} />
				)}
			</div>

			<ControlAdvisory
				inputError={enableButton}
				handleBackClick={configAction[stage].buttonBackClick}
				handleNextClick={configAction[stage].buttonNextClick}
				buttonBackName={configAction[stage].buttonBackName}
				buttonNextName={configAction[stage].buttonNextName}
			/>
		</div>
	);
}

export default FinancialAdvisoryContainer;
